var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadCloudImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#upload-cloud-img_svg__clip0)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ED1B2E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.822 18.822c.65-.651 1.706-.651 2.357 0l6.666 6.666a1.667 1.667 0 11-2.357 2.357L20 22.357l-5.488 5.488a1.667 1.667 0 01-2.357-2.357l6.667-6.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18.333c.92 0 1.667.747 1.667 1.667v15a1.667 1.667 0 11-3.334 0V20c0-.92.747-1.667 1.667-1.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.439 3.348a15 15 0 0114.693 9.985H30a10.003 10.003 0 019.685 7.534 10 10 0 01-4.904 11.246 1.667 1.667 0 01-1.595-2.926 6.667 6.667 0 00-3.187-12.52H27.9c-.76 0-1.423-.514-1.614-1.25A11.667 11.667 0 106.25 26.063 1.667 1.667 0 013.75 28.27 15 15 0 0114.44 3.348z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.822 18.822c.65-.651 1.706-.651 2.357 0l6.666 6.666a1.667 1.667 0 11-2.357 2.357L20 22.357l-5.488 5.488a1.667 1.667 0 01-2.357-2.357l6.667-6.666z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upload-cloud-img_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}

export default SvgUploadCloudImg;